import { render, staticRenderFns } from "./relatedAdd.vue?vue&type=template&id=23b6f0b0&scoped=true&"
import script from "./relatedAdd.vue?vue&type=script&lang=js&"
export * from "./relatedAdd.vue?vue&type=script&lang=js&"
import style0 from "./relatedAdd.vue?vue&type=style&index=0&id=23b6f0b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b6f0b0",
  null
  
)

export default component.exports